import { render, staticRenderFns } from "./SinglePointCogReorder.vue?vue&type=template&id=c6ea60f6&scoped=true&"
import script from "./SinglePointCogReorder.vue?vue&type=script&lang=ts&"
export * from "./SinglePointCogReorder.vue?vue&type=script&lang=ts&"
import style0 from "./SinglePointCogReorder.vue?vue&type=style&index=0&id=c6ea60f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ea60f6",
  null
  
)

export default component.exports